/* WARMIX — scripts propios (un init por componente) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.wx-reveal:not(.wx-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('wx-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('wx-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* Cuenta atrás: data-mode="medianoche" (se reinicia cada día) o "fecha" (data-end="2026-10-31T23:59") */
  function initCountdowns() {
    document.querySelectorAll('[data-wx-countdown]').forEach(function (el) {
      if (el.dataset.wxReady) return;
      el.dataset.wxReady = '1';
      var mode = el.dataset.mode || 'medianoche';
      var endFixed = el.dataset.end ? new Date(el.dataset.end.replace(' ', 'T')) : null;
      var bar = el.querySelector('.wx-bar i');
      var box = el.closest('[data-wx-urgency]') || el;
      function end() {
        if (mode === 'fecha' && endFixed && !isNaN(endFixed)) return endFixed;
        var d = new Date(); d.setHours(24, 0, 0, 0); return d;
      }
      function tick() {
        var ms = end() - new Date();
        if (ms <= 0) {
          if (mode === 'fecha') { box.style.display = 'none'; return; }
          ms = 0;
        }
        var s = Math.floor(ms / 1000);
        var parts = { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
        if (mode !== 'fecha') { parts.h += parts.d * 24; parts.d = 0; }
        Object.keys(parts).forEach(function (k) {
          var t = el.querySelector('[data-u="' + k + '"]');
          if (t) t.textContent = pad(parts[k]);
        });
        var dWrap = el.querySelector('[data-u-wrap="d"]');
        if (dWrap) dWrap.style.display = parts.d > 0 ? '' : 'none';
        if (bar) {
          var span = mode === 'fecha' ? 7 * 86400000 : 86400000;
          bar.style.width = Math.max(4, Math.min(100, (ms / span) * 100)) + '%';
        }
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* "X personas están viendo este producto" (número entre min y max que varía suavemente) */
  function initViewers() {
    document.querySelectorAll('[data-wx-viewers]').forEach(function (el) {
      var min = parseInt(el.dataset.min, 10) || 8;
      var max = parseInt(el.dataset.max, 10) || 30;
      if (max < min) max = min;
      var out = el.querySelector('b');
      var n = min + Math.floor(Math.random() * (max - min + 1));
      out.textContent = n;
      setInterval(function () {
        n += Math.floor(Math.random() * 5) - 2;
        n = Math.max(min, Math.min(max, n));
        out.textContent = n;
      }, 4500);
    });
  }

  /* Mapa de calor: al pasar por un punto, resalta su característica */
  function initHotspots() {
    document.querySelectorAll('[data-wx-mapa]').forEach(function (root) {
      var spots = root.querySelectorAll('.wx-hotspot');
      var feats = root.querySelectorAll('.wx-feat');
      function act(i) { feats.forEach(function (f, j) { f.classList.toggle('is-active', i === j); }); }
      spots.forEach(function (s, i) {
        s.addEventListener('mouseenter', function () { act(i); });
        s.addEventListener('click', function () { act(i); });
      });
      feats.forEach(function (f, i) { f.addEventListener('mouseenter', function () { act(i); }); });
      act(0);
    });
  }

  /* Página de producto */
  function initProduct() {
    var root = document.querySelector('[data-wx-product]');
    if (!root) return;
    var dataEl = root.querySelector('[data-wx-product-json]');
    var data = dataEl ? JSON.parse(dataEl.textContent) : null;
    var form = root.querySelector('form[data-wx-form]');
    var idInput = form.querySelector('input[name="id"]');
    var mainImg = root.querySelector('[data-wx-main]');
    var thumbs = root.querySelectorAll('[data-wx-thumb]');
    var atc = root.querySelectorAll('[data-wx-atc]');
    var money = root.dataset.moneyFormat || '{{amount_with_comma_separator}} €';

    function fmt(cents) {
      var v = (cents / 100).toFixed(2);
      var comma = v.replace('.', ',');
      return money
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
        .replace(/\{\{\s*amount\s*\}\}/, v);
    }

    function showImage(src, id) {
      if (!mainImg || !src) return;
      mainImg.style.opacity = 0;
      setTimeout(function () { mainImg.src = src; mainImg.removeAttribute('srcset'); mainImg.style.opacity = 1; }, 150);
      thumbs.forEach(function (t) { t.classList.toggle('is-active', String(t.dataset.mediaId) === String(id)); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showImage(t.dataset.src, t.dataset.mediaId); });
    });

    function update() {
      if (!data) return;
      var opts = [];
      root.querySelectorAll('[data-wx-option]').forEach(function (g) {
        var c = g.querySelector('input:checked');
        opts.push(c ? c.value : null);
        var lab = g.querySelector('[data-wx-option-value]');
        if (lab && c) lab.textContent = c.value;
      });
      var v = data.variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      if (!v) return;
      idInput.value = v.id;
      root.querySelectorAll('[data-wx-price]').forEach(function (e) { e.textContent = fmt(v.price); });
      var hasCmp = v.compare_at_price && v.compare_at_price > v.price;
      root.querySelectorAll('[data-wx-compare]').forEach(function (e) { e.textContent = hasCmp ? fmt(v.compare_at_price) : ''; e.style.display = hasCmp ? '' : 'none'; });
      root.querySelectorAll('[data-wx-save]').forEach(function (e) {
        e.style.display = hasCmp ? '' : 'none';
        if (hasCmp) e.textContent = e.dataset.tpl.replace('[ahorro]', fmt(v.compare_at_price - v.price)).replace('[porcentaje]', Math.round((1 - v.price / v.compare_at_price) * 100));
      });
      atc.forEach(function (b) {
        b.disabled = !v.available;
        var t = b.querySelector('[data-wx-atc-text]');
        if (t) t.textContent = v.available ? b.dataset.textOn : b.dataset.textOff;
      });
      if (v.featured_media) showImage(v.featured_media.src, v.featured_media.id);
      if (window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    root.querySelectorAll('[data-wx-option] input').forEach(function (i) { i.addEventListener('change', update); });

    var qty = root.querySelector('[data-wx-qty]');
    if (qty) {
      var qi = qty.querySelector('input');
      qty.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = (parseInt(qi.value, 10) || 1) + parseInt(b.dataset.step, 10);
          qi.value = Math.max(1, Math.min(99, n));
        });
      });
    }

    function addToCart(e) {
      if (e) e.preventDefault();
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      atc.forEach(function (b) { b.classList.add('is-loading'); });
      var fd = new FormData(form);
      Array.from(fd.keys()).forEach(function (k) { if (k.indexOf('wx-opt') === 0) fd.delete(k); });
      if (cart && cart.getSectionsToRender) {
        fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        fd.append('sections_url', window.location.pathname);
        if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
      }
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res.status) { alert(res.description || res.message); return; }
        if (cart && cart.renderContents) {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(res);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      }).catch(function () { form.submit(); })
        .finally(function () { atc.forEach(function (b) { b.classList.remove('is-loading'); }); });
    }
    form.addEventListener('submit', addToCart);
    root.querySelectorAll('[data-wx-atc-sticky]').forEach(function (b) { b.addEventListener('click', addToCart); });

    var sticky = root.querySelector('.wx-sticky');
    var mainBtn = form.querySelector('[data-wx-atc]');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var below = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', below);
        });
      }).observe(mainBtn);
    }
  }

  function initAll() {
    initReveal(); initCountdowns(); initViewers(); initHotspots(); initProduct();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function () { initReveal(); initCountdowns(); initViewers(); initHotspots(); });
})();
